import { AnyAction, Reducer } from 'redux';

import {
  TOGGLE_PANEL_ACTIONS,
  TOGGLE_PANEL_CCENTER,
  TOGGLE_PANEL_CURVES,
  TOGGLE_PANEL_OPERATION,
  TOGGLE_PANEL_SIMULATOR
} from './toolbar.types';

export interface ToolbarState {
  openPanelOperation: boolean;
  openPanelActions: boolean;
  openPanelCurves: boolean;
  openPanelDispatch: boolean;
  openPanelCCenter: boolean;
  openPanelSimulator: boolean;
}

const initialState: ToolbarState = {
  openPanelOperation: false,
  openPanelActions: false,
  openPanelCurves: false,
  openPanelDispatch: false,
  openPanelCCenter: false,
  openPanelSimulator: false
};

const reducer: Reducer<ToolbarState> = (
  state: ToolbarState = initialState,
  action: AnyAction = { type: undefined }
) => {
  switch (action.type) {
    case TOGGLE_PANEL_OPERATION:
    case TOGGLE_PANEL_ACTIONS:
    case TOGGLE_PANEL_CURVES:
    case TOGGLE_PANEL_CCENTER:
    case TOGGLE_PANEL_SIMULATOR:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default reducer;
